module.exports = __webpack_public_path__ + "media/application/images/svgs/coffee-6fa5427fdc6280562bac0d77ce549596.svg";